import * as api from '../../api/maintenance/websiteAdmin';
import { makeApiActionCreatorV3 } from '../utils';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import {
  authenticationTokenSelector,
  eventServiceSelector,
  publicServiceSelector,
} from '../../selectors/global';
import { AppraisalNoticeFormsSelector } from '../../selectors/maintenance/websiteAdmin';
import { userSelector } from '@modules/bi/selectors/search';

const namespace = 'GLOBAL/WEBSITE_ADMIN';

export const DOWNLOAD_FILE = createRequestTypes(`${namespace}/DOWNLOAD_FILE`);

export const downloadFile = makeApiActionCreatorV3(
  api.downloadFile,
  DOWNLOAD_FILE[START],
  DOWNLOAD_FILE[SUCCESS],
  DOWNLOAD_FILE[ERROR],
);

export const DOWNLOAD_FILE_IN_BROWSER = createRequestTypes(
  `${namespace}/DOWNLOAD_FILE_IN_BROWSER`,
);

export const downloadFileInBrowser = makeApiActionCreatorV3(
  api.downloadFileInBrowser,
  DOWNLOAD_FILE_IN_BROWSER[START],
  DOWNLOAD_FILE_IN_BROWSER[SUCCESS],
  DOWNLOAD_FILE_IN_BROWSER[ERROR],
);

export const FETCH_REPORTS = createRequestTypes(`${namespace}/FETCH_REPORTS`);

export const fetchReports = makeApiActionCreatorV3(
  api.fetchReports,
  FETCH_REPORTS[START],
  FETCH_REPORTS[SUCCESS],
  FETCH_REPORTS[ERROR],
);

export const FETCH_MAP_CONFIG = createRequestTypes(
  `${namespace}/FETCH_MAP_CONFIG`,
);

export const fetchMapConfiguration = makeApiActionCreatorV3(
  api.fetchMapConfiguration,
  FETCH_MAP_CONFIG[START],
  FETCH_MAP_CONFIG[SUCCESS],
  FETCH_MAP_CONFIG[ERROR],
);

export const UPDATE_MAG_CONFIG = createRequestTypes(
  `${namespace}/UPDATE_MAP_CONFIG`,
);

export const updateMapConfiguration = makeApiActionCreatorV3(
  api.updateMapConfiguration,
  UPDATE_MAG_CONFIG[START],
  UPDATE_MAG_CONFIG[SUCCESS],
  UPDATE_MAG_CONFIG[ERROR],
);

export const FETCH_REPORT = createRequestTypes(`${namespace}/FETCH_REPORT`);

export const fetchReport = makeApiActionCreatorV3(
  api.fetchReport,
  FETCH_REPORT[START],
  FETCH_REPORT[SUCCESS],
  FETCH_REPORT[ERROR],
);

export const DELETE_REPORT = createRequestTypes(`${namespace}/DELETE_REPORT`);

export const deleteReport = makeApiActionCreatorV3(
  api.deleteReport,
  DELETE_REPORT[START],
  DELETE_REPORT[SUCCESS],
  DELETE_REPORT[ERROR],
);

export const FETCH_COUNTIES = createRequestTypes(`${namespace}/FETCH_COUNTIES`);

export const fetchCounties = makeApiActionCreatorV3(
  api.fetchCounties,
  FETCH_COUNTIES[START],
  FETCH_COUNTIES[SUCCESS],
  FETCH_COUNTIES[ERROR],
);

export const FETCH_MEETING_LOCATIONS = createRequestTypes(
  `${namespace}/FETCH_MEETING_LOCATIONS`,
);

export const fetchMeetingLocations = makeApiActionCreatorV3(
  api.fetchMeetingLocations,
  FETCH_MEETING_LOCATIONS[START],
  FETCH_MEETING_LOCATIONS[SUCCESS],
  FETCH_MEETING_LOCATIONS[ERROR],
);

export const FETCH_MEETING_TYPES = createRequestTypes(
  `${namespace}/FETCH_MEETING_TYPES`,
);

export const fetchMeetingTypes = makeApiActionCreatorV3(
  api.fetchMeetingTypes,
  FETCH_MEETING_TYPES[START],
  FETCH_MEETING_TYPES[SUCCESS],
  FETCH_MEETING_TYPES[ERROR],
);

export const SET_MEETING_ORDER = createRequestTypes(
  `${namespace}/SET_MEETING_ORDER`,
);

export const setMeetingOrder = makeApiActionCreatorV3(
  api.setMeetingOrder,
  SET_MEETING_ORDER[START],
  SET_MEETING_ORDER[SUCCESS],
  SET_MEETING_ORDER[ERROR],
);

export const SET_MEMBER_ORDER = createRequestTypes(
  `${namespace}/SET_MEMBER_ORDER`,
);

export const setMemberOrder = makeApiActionCreatorV3(
  api.setMemberOrder,
  SET_MEMBER_ORDER[START],
  SET_MEMBER_ORDER[SUCCESS],
  SET_MEMBER_ORDER[ERROR],
);

export const SET_LINK_ORDER = createRequestTypes(`${namespace}/SET_LINK_ORDER`);

export const setLinkOrder = makeApiActionCreatorV3(
  api.setLinkOrder,
  SET_LINK_ORDER[START],
  SET_LINK_ORDER[SUCCESS],
  SET_LINK_ORDER[ERROR],
);

export const INSERT_MEETING = createRequestTypes(`${namespace}/INSERT_MEETING`);

export const insertMeeting = makeApiActionCreatorV3(
  api.insertMeeting,
  INSERT_MEETING[START],
  INSERT_MEETING[SUCCESS],
  INSERT_MEETING[ERROR],
);

export const INSERT_MEMBER = createRequestTypes(`${namespace}/INSERT_MEMBER`);

export const insertMember = makeApiActionCreatorV3(
  api.insertMember,
  INSERT_MEMBER[START],
  INSERT_MEMBER[SUCCESS],
  INSERT_MEMBER[ERROR],
);

export const DELETE_MEETING = createRequestTypes(`${namespace}/DELETE_MEETING`);

export const deleteMeeting = makeApiActionCreatorV3(
  api.deleteMeeting,
  DELETE_MEETING[START],
  DELETE_MEETING[SUCCESS],
  DELETE_MEETING[ERROR],
);

export const DELETE_MEMBER = createRequestTypes(`${namespace}/DELETE_MEMBER`);

export const deleteMember = makeApiActionCreatorV3(
  api.deleteMember,
  DELETE_MEMBER[START],
  DELETE_MEMBER[SUCCESS],
  DELETE_MEMBER[ERROR],
);

export const UPDATE_MEETING_FILES = createRequestTypes(
  `${namespace}/UPDATE_MEETING_FILES`,
);

export const updateMeetingFiles = makeApiActionCreatorV3(
  api.updateMeetingFiles,
  UPDATE_MEETING_FILES[START],
  UPDATE_MEETING_FILES[SUCCESS],
  UPDATE_MEETING_FILES[ERROR],
);

export const REMOVE_MEETING_FILES = createRequestTypes(
  `${namespace}/REMOVE_MEETING_FILES`,
);

export const removeMeetingFiles = makeApiActionCreatorV3(
  api.removeMeetingFiles,
  REMOVE_MEETING_FILES[START],
  REMOVE_MEETING_FILES[SUCCESS],
  REMOVE_MEETING_FILES[ERROR],
);

export const UPDATE_MEETING = createRequestTypes(`${namespace}/UPDATE_MEETING`);

export const updateMeeting = makeApiActionCreatorV3(
  api.updateMeeting,
  UPDATE_MEETING[START],
  UPDATE_MEETING[SUCCESS],
  UPDATE_MEETING[ERROR],
);

export const UPDATE_MEMBER = createRequestTypes(`${namespace}/UPDATE_MEMBER`);

export const updateMember = makeApiActionCreatorV3(
  api.updateMember,
  UPDATE_MEMBER[START],
  UPDATE_MEMBER[SUCCESS],
  UPDATE_MEMBER[ERROR],
);

export const FETCH_MEETINGS = createRequestTypes(`${namespace}/FETCH_MEETINGS`);

export const fetchMeetings = makeApiActionCreatorV3(
  api.fetchMeetings,
  FETCH_MEETINGS[START],
  FETCH_MEETINGS[SUCCESS],
  FETCH_MEETINGS[ERROR],
);

export const FETCH_LINKS = createRequestTypes(`${namespace}/FETCH_LINKS`);

export const fetchLinks = makeApiActionCreatorV3(
  api.fetchLinks,
  FETCH_LINKS[START],
  FETCH_LINKS[SUCCESS],
  FETCH_LINKS[ERROR],
);

export const FETCH_LINK = createRequestTypes(`${namespace}/FETCH_LINK`);

export const fetchLink = makeApiActionCreatorV3(
  api.fetchLink,
  FETCH_LINK[START],
  FETCH_LINK[SUCCESS],
  FETCH_LINK[ERROR],
);

export const DELETE_LINK = createRequestTypes(`${namespace}/DELETE_LINK`);

export const deleteLink = makeApiActionCreatorV3(
  api.deleteLink,
  DELETE_LINK[START],
  DELETE_LINK[SUCCESS],
  DELETE_LINK[ERROR],
);

export const INSERT_LINK = createRequestTypes(`${namespace}/INSERT_LINK`);

export const insertLink = makeApiActionCreatorV3(
  api.insertLink,
  INSERT_LINK[START],
  INSERT_LINK[SUCCESS],
  INSERT_LINK[ERROR],
);

export const UPDATE_LINK = createRequestTypes(`${namespace}/UPDATE_LINK`);

export const updateLink = makeApiActionCreatorV3(
  api.updateLink,
  UPDATE_LINK[START],
  UPDATE_LINK[SUCCESS],
  UPDATE_LINK[ERROR],
);

export const FETCH_MEETING_INFO = createRequestTypes(
  `${namespace}/FETCH_MEETING_INFO`,
);

export const fetchMeetingInfo = makeApiActionCreatorV3(
  api.fetchMeetingInfo,
  FETCH_MEETING_INFO[START],
  FETCH_MEETING_INFO[SUCCESS],
  FETCH_MEETING_INFO[ERROR],
);

export const INSERT_MEETING_INFO = createRequestTypes(
  `${namespace}/INSERT_MEETING_INFO`,
);

export const insertMeetingInfo = makeApiActionCreatorV3(
  api.insertMeetingInfo,
  INSERT_MEETING_INFO[START],
  INSERT_MEETING_INFO[SUCCESS],
  INSERT_MEETING_INFO[ERROR],
);

export const DELETE_MEETING_INFO = createRequestTypes(
  `${namespace}/DELETE_MEETING_INFO`,
);

export const deleteMeetingInfo = makeApiActionCreatorV3(
  api.deleteMeetingInfo,
  DELETE_MEETING_INFO[START],
  DELETE_MEETING_INFO[SUCCESS],
  DELETE_MEETING_INFO[ERROR],
);

export const FETCH_MEETING = createRequestTypes(`${namespace}/FETCH_MEETING`);

export const fetchMeeting = makeApiActionCreatorV3(
  api.fetchMeeting,
  FETCH_MEETING[START],
  FETCH_MEETING[SUCCESS],
  FETCH_MEETING[ERROR],
);

export const FETCH_MEMBERS = createRequestTypes(`${namespace}/FETCH_MEMBERS`);

export const fetchMembers = makeApiActionCreatorV3(
  api.fetchMembers,
  FETCH_MEMBERS[START],
  FETCH_MEMBERS[SUCCESS],
  FETCH_MEMBERS[ERROR],
);

export const FETCH_REPORT_CATEGORIES = createRequestTypes(
  `${namespace}/FETCH_REPORT_CATEGORIES`,
);

export const fetchReportCategories = makeApiActionCreatorV3(
  api.fetchReportCategories,
  FETCH_REPORT_CATEGORIES[START],
  FETCH_REPORT_CATEGORIES[SUCCESS],
  FETCH_REPORT_CATEGORIES[ERROR],
);

export const FETCH_REPORT_TYPES = createRequestTypes(
  `${namespace}/FETCH_REPORT_TYPES`,
);

export const fetchReportTypes = makeApiActionCreatorV3(
  api.fetchReportTypes,
  FETCH_REPORT_TYPES[START],
  FETCH_REPORT_TYPES[SUCCESS],
  FETCH_REPORT_TYPES[ERROR],
);

export const FETCH_TAXING_UNITS = createRequestTypes(
  `${namespace}/FETCH_TAXING_UNITS`,
);

export const fetchTaxingUnits = makeApiActionCreatorV3(
  api.fetchTaxingUnits,
  FETCH_TAXING_UNITS[START],
  FETCH_TAXING_UNITS[SUCCESS],
  FETCH_TAXING_UNITS[ERROR],
);

export const UPDATE_REPORT = createRequestTypes(`${namespace}/UPDATE_REPORT`);

export const updateReport = makeApiActionCreatorV3(
  api.updateReport,
  UPDATE_REPORT[START],
  UPDATE_REPORT[SUCCESS],
  UPDATE_REPORT[ERROR],
);

export const INSERT_REPORT = createRequestTypes(`${namespace}/INSERT_REPORT`);

export const insertReport = makeApiActionCreatorV3(
  api.insertReport,
  INSERT_REPORT[START],
  INSERT_REPORT[SUCCESS],
  INSERT_REPORT[ERROR],
);

export const FETCH_FORMS = createRequestTypes(`${namespace}/FETCH_FORMS`);

export const fetchForms = makeApiActionCreatorV3(
  api.fetchForms,
  FETCH_FORMS[START],
  FETCH_FORMS[SUCCESS],
  FETCH_FORMS[ERROR],
);

export const FETCH_FORM = createRequestTypes(`${namespace}/FETCH_FORM`);

export const fetchForm = makeApiActionCreatorV3(
  api.fetchForm,
  FETCH_FORM[START],
  FETCH_FORM[SUCCESS],
  FETCH_FORM[ERROR],
);

export const DELETE_FORM = createRequestTypes(`${namespace}/DELETE_FORM`);

export const deleteForm = makeApiActionCreatorV3(
  api.deleteForm,
  DELETE_FORM[START],
  DELETE_FORM[SUCCESS],
  DELETE_FORM[ERROR],
);

export const UPDATE_FORM = createRequestTypes(`${namespace}/UPDATE_FORM`);

export const updateForm = makeApiActionCreatorV3(
  api.updateForm,
  UPDATE_FORM[START],
  UPDATE_FORM[SUCCESS],
  UPDATE_FORM[ERROR],
);

export const INSERT_FORM = createRequestTypes(`${namespace}/INSERT_FORM`);

export const insertForm = makeApiActionCreatorV3(
  api.insertForm,
  INSERT_FORM[START],
  INSERT_FORM[SUCCESS],
  INSERT_FORM[ERROR],
);

export const FETCH_FORM_TYPES = createRequestTypes(
  `${namespace}/FETCH_FORM_TYPES`,
);

export const fetchFormTypes = makeApiActionCreatorV3(
  api.fetchFormTypes,
  FETCH_FORM_TYPES[START],
  FETCH_FORM_TYPES[SUCCESS],
  FETCH_FORM_TYPES[ERROR],
);

export const FETCH_ALL_NEWS = createRequestTypes(`${namespace}/FETCH_ALL_NEWS`);

export const fetchAllNews = makeApiActionCreatorV3(
  api.fetchAllNews,
  FETCH_ALL_NEWS[START],
  FETCH_ALL_NEWS[SUCCESS],
  FETCH_ALL_NEWS[ERROR],
);

export const FETCH_NEWS = createRequestTypes(`${namespace}/FETCH_NEWS`);

export const fetchNews = makeApiActionCreatorV3(
  api.fetchNews,
  FETCH_NEWS[START],
  FETCH_NEWS[SUCCESS],
  FETCH_NEWS[ERROR],
);

export const DELETE_NEWS = createRequestTypes(`${namespace}/DELETE_NEWS`);

export const deleteNews = makeApiActionCreatorV3(
  api.deleteNews,
  DELETE_NEWS[START],
  DELETE_NEWS[SUCCESS],
  DELETE_NEWS[ERROR],
);

export const UPDATE_NEWS = createRequestTypes(`${namespace}/UPDATE_NEWS`);

export const updateNews = makeApiActionCreatorV3(
  api.updateNews,
  UPDATE_NEWS[START],
  UPDATE_NEWS[SUCCESS],
  UPDATE_NEWS[ERROR],
);

export const INSERT_NEWS = createRequestTypes(`${namespace}/INSERT_NEWS`);

export const insertNews = makeApiActionCreatorV3(
  api.insertNews,
  INSERT_NEWS[START],
  INSERT_NEWS[SUCCESS],
  INSERT_NEWS[ERROR],
);

export const SET_NEWS_ORDER = createRequestTypes(`${namespace}/SET_NEWS_ORDER`);

export const setNewsOrder = makeApiActionCreatorV3(
  api.setNewsOrder,
  SET_NEWS_ORDER[START],
  SET_NEWS_ORDER[SUCCESS],
  SET_NEWS_ORDER[ERROR],
);

export const FETCH_ANNOUNCEMENTS = createRequestTypes(
  `${namespace}/FETCH_ANNOUNCEMENTS`,
);

export const fetchAnnouncements = makeApiActionCreatorV3(
  api.fetchAnnouncements,
  FETCH_ANNOUNCEMENTS[START],
  FETCH_ANNOUNCEMENTS[SUCCESS],
  FETCH_ANNOUNCEMENTS[ERROR],
);

export const FETCH_ANNOUNCEMENT = createRequestTypes(
  `${namespace}/FETCH_ANNOUNCEMENT`,
);

export const fetchAnnouncement = makeApiActionCreatorV3(
  api.fetchAnnouncement,
  FETCH_ANNOUNCEMENT[START],
  FETCH_ANNOUNCEMENT[SUCCESS],
  FETCH_ANNOUNCEMENT[ERROR],
);

export const DELETE_ANNOUNCEMENT = createRequestTypes(
  `${namespace}/DELETE_ANNOUNCEMENT`,
);

export const deleteAnnouncement = makeApiActionCreatorV3(
  api.deleteAnnouncement,
  DELETE_ANNOUNCEMENT[START],
  DELETE_ANNOUNCEMENT[SUCCESS],
  DELETE_ANNOUNCEMENT[ERROR],
);

export const UPDATE_ANNOUNCEMENT = createRequestTypes(
  `${namespace}/UPDATE_ANNOUNCEMENT`,
);

export const updateAnnouncement = makeApiActionCreatorV3(
  api.updateAnnouncement,
  UPDATE_ANNOUNCEMENT[START],
  UPDATE_ANNOUNCEMENT[SUCCESS],
  UPDATE_ANNOUNCEMENT[ERROR],
);

export const INSERT_ANNOUNCEMENT = createRequestTypes(
  `${namespace}/INSERT_ANNOUNCEMENT`,
);

export const insertAnnouncement = makeApiActionCreatorV3(
  api.insertAnnouncement,
  INSERT_ANNOUNCEMENT[START],
  INSERT_ANNOUNCEMENT[SUCCESS],
  INSERT_ANNOUNCEMENT[ERROR],
);

export const SET_ANNOUNCEMENTS_ORDER = createRequestTypes(
  `${namespace}/SET_ANNOUNCEMENTS_ORDER`,
);

export const setAnnouncementsOrder = makeApiActionCreatorV3(
  api.setAnnouncementsOrder,
  SET_ANNOUNCEMENTS_ORDER[START],
  SET_ANNOUNCEMENTS_ORDER[SUCCESS],
  SET_ANNOUNCEMENTS_ORDER[ERROR],
);

export const FETCH_LANGUAGES = createRequestTypes(
  `${namespace}/FETCH_LANGUAGES`,
);

export const fetchLanguages = makeApiActionCreatorV3(
  api.fetchLanguages,
  FETCH_LANGUAGES[START],
  FETCH_LANGUAGES[SUCCESS],
  FETCH_LANGUAGES[ERROR],
);

export const FETCH_SETTINGS = createRequestTypes(`${namespace}/FETCH_SETTINGS`);

export const fetchSettings = makeApiActionCreatorV3(
  api.fetchSettings,
  FETCH_SETTINGS[START],
  FETCH_SETTINGS[SUCCESS],
  FETCH_SETTINGS[ERROR],
);

export const UPDATE_SETTINGS = createRequestTypes(
  `${namespace}/UPDATE_SETTINGS`,
);

export const updateSettings = makeApiActionCreatorV3(
  api.updateSettings,
  UPDATE_SETTINGS[START],
  UPDATE_SETTINGS[SUCCESS],
  UPDATE_SETTINGS[ERROR],
);

export const FETCH_ONLINE_FORM_TYPES = createRequestTypes(
  `${namespace}/FETCH_ONLINE_FORM_TYPES`,
);

export const fetchOnlineFormTypes = makeApiActionCreatorV3(
  api.fetchOnlineFormTypes,
  FETCH_ONLINE_FORM_TYPES[START],
  FETCH_ONLINE_FORM_TYPES[SUCCESS],
  FETCH_ONLINE_FORM_TYPES[ERROR],
);

export const UPDATE_ONLINE_FORM_TYPE = createRequestTypes(
  `${namespace}/UPDATE_ONLINE_FORM_TYPE`,
);

export const updateOnlineFormType = makeApiActionCreatorV3(
  api.updateOnlineFormType,
  UPDATE_ONLINE_FORM_TYPE[START],
  UPDATE_ONLINE_FORM_TYPE[SUCCESS],
  UPDATE_ONLINE_FORM_TYPE[ERROR],
);

export const FETCH_PID_RULES = createRequestTypes(
  `${namespace}/FETCH_PID_RULES`,
);

export const fetchPIDRules = makeApiActionCreatorV3(
  api.fetchPIDRules,
  FETCH_PID_RULES[START],
  FETCH_PID_RULES[SUCCESS],
  FETCH_PID_RULES[ERROR],
);

export const UNFLAG_NEW_REPORT = `${namespace}/UNFLAG_NEW_REPORT`;

export const unflagNewReport = () => ({
  type: UNFLAG_NEW_REPORT,
});

export const UNFLAG_NEW_FORM = `${namespace}/UNFLAG_NEW_FORM`;

export const unflagNewForm = () => ({
  type: UNFLAG_NEW_FORM,
});

export const UNFLAG_NEW_NEWS = `${namespace}/UNFLAG_NEW_NEWS`;

export const unflagNewNews = () => ({
  type: UNFLAG_NEW_NEWS,
});

export const UNFLAG_NEW_ANNOUNCEMENT = `${namespace}/UNFLAG_NEW_ANNOUNCEMENT`;

export const unflagNewAnnouncement = () => ({
  type: UNFLAG_NEW_ANNOUNCEMENT,
});

export const FETCH_ALL_QUICK_LINKS = createRequestTypes(
  `${namespace}/FETCH_ALL_QUICK_LINKS`,
);

export const fetchAllQuickLinks = makeApiActionCreatorV3(
  api.fetchAllQuickLinks,
  FETCH_ALL_QUICK_LINKS[START],
  FETCH_ALL_QUICK_LINKS[SUCCESS],
  FETCH_ALL_QUICK_LINKS[ERROR],
);

export const FETCH_QUICK_LINK = createRequestTypes(
  `${namespace}/FETCH_QUICK_LINK`,
);

export const fetchQuickLink = makeApiActionCreatorV3(
  api.fetchQuickLink,
  FETCH_QUICK_LINK[START],
  FETCH_QUICK_LINK[SUCCESS],
  FETCH_QUICK_LINK[ERROR],
);

export const DELETE_QUICK_LINK = createRequestTypes(
  `${namespace}/DELETE_QUICK_LINK`,
);

export const deleteQuickLink = makeApiActionCreatorV3(
  api.deleteQuickLink,
  DELETE_QUICK_LINK[START],
  DELETE_QUICK_LINK[SUCCESS],
  DELETE_QUICK_LINK[ERROR],
);

export const UPDATE_QUICK_LINK = createRequestTypes(
  `${namespace}/UPDATE_QUICK_LINK`,
);

export const updateQuickLink = makeApiActionCreatorV3(
  api.updateQuickLink,
  UPDATE_QUICK_LINK[START],
  UPDATE_QUICK_LINK[SUCCESS],
  UPDATE_QUICK_LINK[ERROR],
);

export const INSERT_QUICK_LINK = createRequestTypes(
  `${namespace}/INSERT_QUICK_LINK`,
);

export const insertQuickLink = makeApiActionCreatorV3(
  api.insertQuickLink,
  INSERT_QUICK_LINK[START],
  INSERT_QUICK_LINK[SUCCESS],
  INSERT_QUICK_LINK[ERROR],
);

export const SET_QUICK_LINK_ORDER = createRequestTypes(
  `${namespace}/SET_QUICK_LINK_ORDER`,
);

export const setQuickLinkOrder = makeApiActionCreatorV3(
  api.setQuickLinkOrder,
  SET_QUICK_LINK_ORDER[START],
  SET_QUICK_LINK_ORDER[SUCCESS],
  SET_QUICK_LINK_ORDER[ERROR],
);

export const FETCH_ALL_TILES = createRequestTypes(
  `${namespace}/FETCH_ALL_TILES`,
);

export const fetchAllTiles = makeApiActionCreatorV3(
  api.fetchAllTiles,
  FETCH_ALL_TILES[START],
  FETCH_ALL_TILES[SUCCESS],
  FETCH_ALL_TILES[ERROR],
);

export const FETCH_TILE = createRequestTypes(`${namespace}/FETCH_TILE`);

export const fetchTile = makeApiActionCreatorV3(
  api.fetchTile,
  FETCH_TILE[START],
  FETCH_TILE[SUCCESS],
  FETCH_TILE[ERROR],
);

export const DELETE_TILE = createRequestTypes(`${namespace}/DELETE_TILE`);

export const deleteTile = makeApiActionCreatorV3(
  api.deleteTile,
  DELETE_TILE[START],
  DELETE_TILE[SUCCESS],
  DELETE_TILE[ERROR],
);

export const UPDATE_TILE = createRequestTypes(`${namespace}/UPDATE_TILE`);

export const updateTile = makeApiActionCreatorV3(
  api.updateTile,
  UPDATE_TILE[START],
  UPDATE_TILE[SUCCESS],
  UPDATE_TILE[ERROR],
);

export const INSERT_TILE = createRequestTypes(`${namespace}/INSERT_TILE`);

export const insertTile = makeApiActionCreatorV3(
  api.insertTile,
  INSERT_TILE[START],
  INSERT_TILE[SUCCESS],
  INSERT_TILE[ERROR],
);

export const SET_TILE_ORDER = createRequestTypes(`${namespace}/SET_TILE_ORDER`);

export const setTileOrder = makeApiActionCreatorV3(
  api.setTileOrder,
  SET_TILE_ORDER[START],
  SET_TILE_ORDER[SUCCESS],
  SET_TILE_ORDER[ERROR],
);

export const UNFLAG_NEW_QUICK_LINK = `${namespace}/UNFLAG_NEW_QUICK_LINK`;

export const unflagNewQuickLink = () => ({
  type: UNFLAG_NEW_QUICK_LINK,
});

export const UNFLAG_NEW_TILE = `${namespace}/UNFLAG_NEW_TILE`;

export const unflagNewTile = () => ({
  type: UNFLAG_NEW_TILE,
});

export const FETCH_APPRAISAL_NOTICE_FORMS = createRequestTypes(
  `${namespace}/FETCH_APPRAISAL_NOTICE_FORMS`,
);

export const fetchAppraisalNoticeForms = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: FETCH_APPRAISAL_NOTICE_FORMS[START],
    });
    const state = getState();
    const authenticationToken = authenticationTokenSelector(state);
    const publicService = publicServiceSelector(state);

    try {
      const response = await api.fetchAppraisalNoticeForms(
        { publicService },
        authenticationToken,
      );

      dispatch({
        type: FETCH_APPRAISAL_NOTICE_FORMS[SUCCESS],
        data: response,
      });

      return response.results;
    } catch (error) {
      console.error('error', error);
      dispatch({
        type: FETCH_APPRAISAL_NOTICE_FORMS[ERROR],
        error,
      });
    }
  };
};

export const FETCH_APPRAISAL_NOTICE_FORM_OPTIONS = createRequestTypes(
  `${namespace}/FETCH_APPRAISAL_NOTICE_FORM_OPTIONS`,
);

export const fetchAppraisalNoticeFormOptions = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: FETCH_APPRAISAL_NOTICE_FORM_OPTIONS[START],
    });
    const state = getState();
    const eventService = eventServiceSelector(state);
    const authenticationToken = authenticationTokenSelector(state);

    try {
      const response = await api.fetchAppraisalNoticeFormOptions(
        { eventService },
        authenticationToken,
      );

      if (response.error) {
        throw new Error(response.error);
      }

      dispatch({
        type: FETCH_APPRAISAL_NOTICE_FORM_OPTIONS[SUCCESS],
        data: response,
      });

      return response.results;
    } catch (error) {
      console.log('error in catch block', error);
      dispatch({
        type: FETCH_APPRAISAL_NOTICE_FORM_OPTIONS[ERROR],
        error,
      });
    }
  };
};

export const DELETE_APPRAISAL_NOTICE_FORM = createRequestTypes(
  `${namespace}/DELETE_APPRAISAL_NOTICE_FORM`,
);

export const deleteAppraisalNoticeForm = (form) => {
  return async (dispatch, getState) => {
    const state = getState();
    const publicService = publicServiceSelector(state);
    const authenticationToken = authenticationTokenSelector(state);
    const originalForm = AppraisalNoticeFormsSelector(state).find(
      (f) =>
        f.publicApprNoticeFormConfigID === form.publicApprNoticeFormConfigID,
    );

    // preemptively delete row, will replace if there's an error
    dispatch({
      type: DELETE_APPRAISAL_NOTICE_FORM,
      data: form,
    });

    try {
      const response = await api.deleteAppraisalNoticeForm(
        { publicService },
        authenticationToken,
        form,
      );

      if (response.error) {
        console.error('error', response.error);
        form.status = response.error?.error;
        dispatch({
          type: UPDATE_APPRAISAL_NOTICE_FORM,
          data: originalForm,
        });
      }
    } catch (error) {
      console.error('error', error);
      form.status = error?.message;
      dispatch({
        type: UPDATE_APPRAISAL_NOTICE_FORM,
        data: originalForm,
      });
    }
  };
};
export const UPDATE_APPRAISAL_NOTICE_FORMS = `${namespace}/UPDATE_APPRAISAL_NOTICE_FORMS`;

export const updateAppraisalNoticeForms = (forms) => {
  return async (dispatch) => {
    dispatch({
      type: UPDATE_APPRAISAL_NOTICE_FORMS,
      data: forms,
    });
  };
};
export const UPDATE_APPRAISAL_NOTICE_FORM = `${namespace}/UPDATE_APPRAISAL_NOTICE_FORM`;

export const updateAppraisalNoticeForm = (form) => {
  return async (dispatch, getState) => {
    const state = getState();
    const publicService = publicServiceSelector(state);
    const authenticationToken = authenticationTokenSelector(state);
    const originalForm = AppraisalNoticeFormsSelector(state).find(
      (f) =>
        f.publicApprNoticeFormConfigID === form.publicApprNoticeFormConfigID,
    );
    const { email } = userSelector(state);

    if (
      !(
        form?.pYear &&
        form?.formID &&
        form?.formName &&
        form?.displayEnabled !== undefined &&
        form?.eventType
      )
    ) {
      // update data with error message
      form.status = 'Row is incomplete';
      dispatch({
        type: UPDATE_APPRAISAL_NOTICE_FORM,
        data: form,
      });
    } else {
      form.status = undefined;
      form.updatedBy = email;

      try {
        // update form data preemptively, will get returned to original state if there's an error
        dispatch({
          type: UPDATE_APPRAISAL_NOTICE_FORM,
          data: form,
        });

        let response;
        if (form.new) {
          response = await api.addAppraisalNoticeForm(
            { publicService },
            authenticationToken,
            form,
          );
        } else {
          response = await api.updateAppraisalNoticeForm(
            { publicService },
            authenticationToken,
            form,
          );
        }
        if (response.error) {
          // revert form data to original state, with error message
          originalForm.status = response.error?.error;
          dispatch({
            type: UPDATE_APPRAISAL_NOTICE_FORM,
            data: originalForm,
          });
        } else {
          // ensure that newly-added rows are marked as not new
          form.new = false;
          dispatch({
            type: UPDATE_APPRAISAL_NOTICE_FORM,
            data: form,
          });
        }
      } catch (error) {
        // revert form data to original state, with error message
        originalForm.status = error.message;
        dispatch({
          type: UPDATE_APPRAISAL_NOTICE_FORM,
          data: originalForm,
        });
      }
    }
  };
};
